import { render, staticRenderFns } from "./STTIMIRiskScore.vue?vue&type=template&id=700481c2&scoped=true"
import script from "./STTIMIRiskScore.vue?vue&type=script&lang=js"
export * from "./STTIMIRiskScore.vue?vue&type=script&lang=js"
import style0 from "./STTIMIRiskScore.vue?vue&type=style&index=0&id=700481c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700481c2",
  null
  
)

export default component.exports